import React, { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import axios from 'axios';
import { AuthService as AuthInstance } from "../services/firebase/firebaseServiceNEW";
import { FormComponent } from "../components/FormComponent";

export default function UserAdd() {
    const user = useSelector(state => state.user);

    const [inputFields, setInputFields] = useState({
        currentPassword: '',
        newPassword: ''
    });

    const validateData = [
        {
            "inputName": "currentPassword",
            "displayName": "Current Password is required!"
        },
        {
            "inputName": "newPassword",
            "displayName": "New Password is required!"
        },
    ];


    const handleProfileChange = (event) => {
        const { name, value } = event.target;
        setInputFields({
            ...inputFields,
            [name]: value
        });
        if (value.trim() !== '') {
            event.target.classList.remove('border-danger');
        }
    }

    async function handleProfileSubmit(event) {
        event.preventDefault();
        const requiredFields = ['currentPassword', 'newPassword'];
        const formComponentInstance = FormComponent(requiredFields, inputFields, validateData)
        if ((formComponentInstance) && inputFields.newPassword) {
            if (inputFields.newPassword === inputFields.currentPassword) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    html: `<strong>Please use Different values</strong>`,
                });
            } else {
                try {
                    const result = await AuthInstance.changePassword(inputFields.currentPassword, inputFields.newPassword);
                    console.log('result', result);
                    if (result === true) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Success...',
                            html: `<strong>Password change successfully.</strong>`,
                        });
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            html: `<strong>${result.message ? result?.message : 'Something happened in the log'}.</strong>`,
                        });
                    }
                } catch (error) {
                    // console.error('Error:', error);
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'An error occurred while changing the password. Please try again later.',
                    });
                }
            }
        }
    }






    return (
        <section className="page-content sec-padding">

            <div className="container">
                <div className="page-content-details">
                    <div className="sec-title row">
                        <h3 className="mx-auto">Edit Password</h3>
                    </div>
                    <div className="row">
                        <div className="col-md-10 mx-auto">
                            <div className="card AddressView">
                                <div className="card-body">
                                    <form className="mb-4" method="post">

                                        <div className="form-group row">
                                            <label className="form-label col-md-4" htmlFor="email"> Email <span className="text-danger">*</span></label>
                                            <div className="col-md-8 d-flex position-relative">
                                                <input name="email" type="text"
                                                    className="form-control"
                                                    disabled
                                                    //      {...register2("email", { required: true })}
                                                    defaultValue={user.email}
                                                />
                                            </div>
                                        </div>


                                        <div className="form-group row">
                                            <label className="form-label col-md-4" htmlFor="currentPassword"> Current Password:</label>
                                            <div className="col-md-8 d-flex position-relative">
                                                <input name="currentPassword" type="password"
                                                    className="form-control"
                                                    value={inputFields.currentPassword} onChange={handleProfileChange} />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="form-label col-md-4" htmlFor="newPassword"> New Password:</label>
                                            <div className="col-md-8 d-flex position-relative">
                                                <input name="newPassword" type="password"
                                                    className="form-control"
                                                    value={inputFields.newPassword} onChange={handleProfileChange} />
                                            </div>
                                        </div>
                                        <div className="form-group text-center">
                                            <button type="submit" className="btn btn-primary btn-lg" onClick={handleProfileSubmit}>Update Password</button>

                                        </div>
                                    </form>



                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </section>
    )
}